export default __webpack_public_path__ + "23778200bf955a2cdbaa68b2c86da6ef.svg";